// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as NotesRouteImport } from './routes/notes'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SymbalismIndexRouteImport } from './routes/symbalism/index'
import { Route as SlapStickerMakerIndexRouteImport } from './routes/slap-sticker-maker/index'
import { Route as RecipesIndexRouteImport } from './routes/recipes/index'
import { Route as PianoNoteTesterIndexRouteImport } from './routes/piano-note-tester/index'
import { Route as MusicIndexRouteImport } from './routes/music/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as RecipesAddRecipeRouteImport } from './routes/recipes/addRecipe'
import { Route as RecipesRecipeIdRouteImport } from './routes/recipes/$recipeId'
import { Route as MusicAddRouteImport } from './routes/music/add'
import { Route as MusicMusicIdRouteImport } from './routes/music/$musicId'
import { Route as NotesIndexRouteImport } from './routes/notes/index'
import { Route as NotesNewRouteImport } from './routes/notes/new'
import { Route as NotesNoteIdRouteImport } from './routes/notes/$noteId'

const NotesRoute = NotesRouteImport.update({
            id: '/notes',path: '/notes',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SymbalismIndexRoute = SymbalismIndexRouteImport.update({
            id: '/symbalism/',path: '/symbalism/',getParentRoute: () => rootRouteImport
          })
const SlapStickerMakerIndexRoute = SlapStickerMakerIndexRouteImport.update({
            id: '/slap-sticker-maker/',path: '/slap-sticker-maker/',getParentRoute: () => rootRouteImport
          })
const RecipesIndexRoute = RecipesIndexRouteImport.update({
            id: '/recipes/',path: '/recipes/',getParentRoute: () => rootRouteImport
          })
const PianoNoteTesterIndexRoute = PianoNoteTesterIndexRouteImport.update({
            id: '/piano-note-tester/',path: '/piano-note-tester/',getParentRoute: () => rootRouteImport
          })
const MusicIndexRoute = MusicIndexRouteImport.update({
            id: '/music/',path: '/music/',getParentRoute: () => rootRouteImport
          })
const LoginIndexRoute = LoginIndexRouteImport.update({
            id: '/login/',path: '/login/',getParentRoute: () => rootRouteImport
          })
const RecipesAddRecipeRoute = RecipesAddRecipeRouteImport.update({
            id: '/recipes/addRecipe',path: '/recipes/addRecipe',getParentRoute: () => rootRouteImport
          })
const RecipesRecipeIdRoute = RecipesRecipeIdRouteImport.update({
            id: '/recipes/$recipeId',path: '/recipes/$recipeId',getParentRoute: () => rootRouteImport
          })
const MusicAddRoute = MusicAddRouteImport.update({
            id: '/music/add',path: '/music/add',getParentRoute: () => rootRouteImport
          })
const MusicMusicIdRoute = MusicMusicIdRouteImport.update({
            id: '/music/$musicId',path: '/music/$musicId',getParentRoute: () => rootRouteImport
          })
const NotesIndexRoute = NotesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => NotesRoute
          })
const NotesNewRoute = NotesNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => NotesRoute
          })
const NotesNoteIdRoute = NotesNoteIdRouteImport.update({
            id: '/$noteId',path: '/$noteId',getParentRoute: () => NotesRoute
          })





const NotesRouteChildren = {
  NotesNoteIdRoute: NotesNoteIdRoute,NotesNewRoute: NotesNewRoute,NotesIndexRoute: NotesIndexRoute
}

const NotesRouteWithChildren = NotesRoute._addFileChildren(NotesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,NotesRoute: NotesRouteWithChildren,MusicMusicIdRoute: MusicMusicIdRoute,MusicAddRoute: MusicAddRoute,RecipesRecipeIdRoute: RecipesRecipeIdRoute,RecipesAddRecipeRoute: RecipesAddRecipeRoute,LoginIndexRoute: LoginIndexRoute,MusicIndexRoute: MusicIndexRoute,PianoNoteTesterIndexRoute: PianoNoteTesterIndexRoute,RecipesIndexRoute: RecipesIndexRoute,SlapStickerMakerIndexRoute: SlapStickerMakerIndexRoute,SymbalismIndexRoute: SymbalismIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)